import { notification } from 'antd';
import { gwGet } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import actionTypes from '../actionsFactory/types';

const {
  SET_BLOG_PAGE_SUCCESS,
  GET_BLOG_LIST_SUCCESS,
  GET_BLOG_DETAIL_SUCCESS,
  GET_BLOG_DETAIL_ERROR,
} = actionTypes;

const setFailedMsg = msg => (notification.error({
  message: msg || 'Network is not good, Please try later.',
}));

export const getBlogListData = async (page, pageSize = 20, lang, req, store) => {
  store.dispatch({ type: SET_BLOG_PAGE_SUCCESS, data: page });
  const data = await gwGet(`${API_PATH.BLOG_LIST_API}?lang=${lang}&pageIndex=${page}&pageSize=${pageSize}`, {}, req);
  if (data && data.success) {
    store.dispatch({ type: GET_BLOG_LIST_SUCCESS, data });
  }
};

export const getBlogList = (page, lang, pageSize = 20, pageType) => async dispatch => {
  dispatch({ type: SET_BLOG_PAGE_SUCCESS, data: page });
  try {
    const data = await gwGet(`${API_PATH.BLOG_LIST_API}?lang=${lang}&pageIndex=${page}&pageSize=${pageSize}`);
    if (data && data.success) {
      dispatch({ type: GET_BLOG_LIST_SUCCESS, data, pageType });
    } else {
      setFailedMsg(data.message);
    }
  } catch (error) {
    // nothing
  }
};

export const getBlogDetail = (id, lang, req) => async dispatch => {
  let resData = {};
  try {
    const data = await gwGet(`${API_PATH.BLOG_DETAIL_API}?lang=${lang}&articleId=${id}`, {}, req);
    if (data && data.success) {
      resData = data.data;
      dispatch({ type: GET_BLOG_DETAIL_SUCCESS, data: resData });
    } else {
      throw new Error('blog not exist');
    }
  } catch (error) {
    dispatch({ type: GET_BLOG_DETAIL_ERROR });
  }
  return resData;
};

export default {};
